import React, { FC } from "react";
import Grow from "@mui/material/Grow";
import { Typography, Paper } from "@mui/material";
import { RowLayout, ColLayout } from "../../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useConfigSelector from "./useConfigSelector";

const StyledPaper = styled(Paper)({
  "&:hover": { cursor: "pointer" },
  padding: 10,
  margin: 10,
});

const StyledImg = styled("img")({
  height: "auto",
  width: 250,
});


interface SwingConfigsProps {
  setWidthMeasureImg: (img: string | undefined) => void;
  swingDir: string;
  sType: string;
  sLite: string;
  isPivot?: boolean;
}

const SwingConfigs: FC<SwingConfigsProps> = ({
  setWidthMeasureImg,
  swingDir,
  sType,
  sLite,
  isPivot = false,
}) => {
  const {
    handleClickSingleSidelite,
    handleClick,
    selectedSide,
    swingConfigImgs,
    showPivotLever
  } = useConfigSelector(isPivot, sType, sLite, swingDir, setWidthMeasureImg);

  return (
    <ColLayout style={{ paddingLeft: 5, paddingRight: 5 }}>
      {sType ? (
        <>
          <ColLayout style={{ width: "100%" }}>
            {selectedSide ? (
              <Typography variant="h5" style={{ color: "#57d5f2" }}>
                You Selected: {selectedSide}
              </Typography>
            ) : (
              <Typography style={{ fontWeight: "bold" }} variant="h6">
                Select a Configuration Option
              </Typography>
            )}
            <Typography variant="caption">* As Viewed from Exterior</Typography>
          </ColLayout>
          {swingConfigImgs?.img4 && (
            <Typography style={{ fontWeight: "bold" }} variant="h6">
              Jamb Leg Side
            </Typography>
          )}
          <RowLayout>
            <Grow in={true}>
              <ColLayout>
                <StyledPaper
                  onClick={() => handleClick("left")}
                  elevation={3}
                  style={{
                    marginRight: 40,
                    border:
                      selectedSide === "Left Hinged" ||
                      selectedSide === "Left Hinged Handle Opposite Sidelite" ||
                      selectedSide === "Left Hinged Left Sidelite"
                        ? "4px solid #57d5f2"
                        : "",
                  }}
                >
                  <StyledImg
                    src={
                      showPivotLever
                        ? swingConfigImgs?.img1Lever
                        : swingConfigImgs?.img1
                    }
                    alt="swing configuration"
                  />
                </StyledPaper>
                <Typography style={{ padding: 10 }}>
                  {sType === "Pair Swing" && "Primary"} Left Hinged
                </Typography>
              </ColLayout>
            </Grow>
            {swingConfigImgs?.img2 && (
              <Grow in={true}>
                <ColLayout>
                  <StyledPaper
                    onClick={() => handleClick("right")}
                    elevation={3}
                    style={{
                      border:
                        selectedSide === "Right Hinged" ||
                        selectedSide === "Right Hinged Handle Opposite Sidelite" ||
                        selectedSide === "Right Hinged Left Sidelite"
                          ? "4px solid #57d5f2"
                          : "",
                    }}
                  >
                    <StyledImg
                      src={
                        showPivotLever
                          ? swingConfigImgs?.img2Lever
                          : swingConfigImgs?.img2
                      }
                      alt="swing 2 configuration"
                    />
                  </StyledPaper>
                  <Typography style={{ padding: 10 }}>
                    {sType === "Pair Swing" && "Primary"} Right Hinged
                  </Typography>
                </ColLayout>
              </Grow>
            )}
          </RowLayout>
          {swingConfigImgs?.img4 && (
            <>
              <Typography style={{ fontWeight: "bold" }} variant="h6">
                Sidelite Side
              </Typography>

              <RowLayout
                style={{ width: "100%", justifyContent: "space-between" }}
              >
                {swingConfigImgs.img3 && (
                  <Grow in={true}>
                    <ColLayout>
                      <StyledPaper
                        onClick={() => handleClickSingleSidelite("left")}
                        elevation={3}
                        style={{
                          border:
                            selectedSide ===
                            "Left Hinged Handle Facing Sidelite" ||
                            selectedSide === "Left Hinged Right Sidelite"
                              ? "4px solid #57d5f2"
                              : "",
                        }}
                      >
                        <StyledImg
                          src={
                            showPivotLever
                              ? swingConfigImgs?.img3Lever
                              : swingConfigImgs?.img3
                          }
                          alt="swing 3 configuration"
                        />
                      </StyledPaper>
                      <Typography style={{ padding: 10 }}>
                        {sType === "Pair Swing" && "Primary"} Left Hinged
                      </Typography>
                    </ColLayout>
                  </Grow>
                )}
                {swingConfigImgs?.img4 && (
                  <Grow in={true}>
                    <ColLayout>
                      <StyledPaper
                        onClick={() => handleClickSingleSidelite("right")}
                        elevation={3}
                        style={{
                          border:
                            selectedSide ===
                            "Right Hinged Handle Facing Sidelite" ||
                            selectedSide === "Right Hinged Right Sidelite"
                              ? "4px solid #57d5f2"
                              : "",
                        }}
                      >
                        <StyledImg
                          src={
                            showPivotLever
                              ? swingConfigImgs?.img4Lever
                              : swingConfigImgs?.img4
                          }
                          alt="swing 4 configuration"
                        />
                      </StyledPaper>
                      <Typography style={{ padding: 10 }}>
                        {sType === "Pair Swing" && "Primary"} Right Hinged
                      </Typography>
                    </ColLayout>
                  </Grow>
                )}
              </RowLayout>
            </>
          )}
        </>
      ) : (
        <Typography variant="h5">Select a Swing Type</Typography>
      )}
    </ColLayout>
  );
};

export default SwingConfigs;
